import React from 'react'
import {Helmet} from 'react-helmet'
import PrivacyPolicyComponent from './PrivacyPolicyComponent'

import MainLayout from 'src/components/MainLayout'
import styled from 'styled-components'

const Wrapper = styled.section`
  background-color: #f3f3f3;
`

const PrivacyPolicyPage: React.FC = () => {
    return (
        <MainLayout>
            <Helmet>
                <title>
                    Senspark | Privacy Policy
                </title>
                <meta
                    property='og:title'
                    content='Senspark | Privacy Policy'
                />
            </Helmet>
            <Wrapper>
                <PrivacyPolicyComponent />
            </Wrapper>
        </MainLayout>
    )
}

export default PrivacyPolicyPage
